import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {ModelManager} from 'models/managers/ModelManager';
import {getStore} from 'redux-stores/Store';
import * as InputReduxActions from 'requests/inputs/InputReduxActions';
import {SampleGroup} from 'workflows/WorkflowConstants';

import {RequestSampleGroupsModelSelector} from './RequestSampleGroupsModelSelector';

export default class RequestSampleGroupsModelManager extends ModelManager<ManagedModelType.SAMPLE_GROUPS_BY_REQUEST_ID> {
  constructor() {
    super(ManagedModelType.SAMPLE_GROUPS_BY_REQUEST_ID);
  }

  async doFetchMulti(keys: Array<string>): Promise<void> {
    await getStore().dispatch(InputReduxActions.fetchRequestSampleGroups(keys));
  }

  getModel(modelKey: string): Array<SampleGroup> | null {
    return new RequestSampleGroupsModelSelector(getStore().getState()).getSampleGroups(modelKey);
  }
}
